package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_12_22_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes at the Hexagon Party Battle Open.  The Dwarves Assembly wins the competition. Matty Footseller escaped. Bigglesworth hurries to collect his 20 gold winnings from his 5 gold wager. The heroes briefly try to find and follow an illusioned person, but give us because they don’t want to walk into a trap. The heroes are reassured by the presence of guards following them. They return to the inn. Due to the recent threats, the heroes setup a watch rotation for the night.")
    }
}
